import { FaHeart, FaStar, FaShoppingCart } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { IMAGE_URL } from "../config/config";
import API_URL from "../config/config";
import axios from "axios";
import "../css/productcard.css";

function ProductCard({ product }) {

  const navigate = useNavigate();

  const image = product.image
    ? `${IMAGE_URL}${product.image}`
    : "https://via.placeholder.com/300x300?text=No+Image";

  const finalPrice =
    product.discount > 0
      ? (
          product.price -
          (product.price * product.discount) / 100
        ).toFixed(2)
      : product.price;

  const handleAddToCart = async () => {

    const user = JSON.parse(localStorage.getItem("user"));

    if (!user) {
      alert("Please login first.");
      navigate("/login");
      return;
    }

    try {

      await axios.post(`${API_URL}/cart`, {
        user_id: user.id,
        product_id: product.id,
      });

      alert("Product added to cart!");

    } catch (err) {

      console.log(err);
      alert("Unable to add product.");

    }

  };


  const handleWishlist = async () => {

  const user = JSON.parse(localStorage.getItem("user"));

  if (!user) {
    alert("Please login first.");
    navigate("/login");
    return;
  }

  try {

    await axios.post(`${API_URL}/wishlist`, {
      user_id: user.id,
      product_id: product.id
    });

    alert("Added to Wishlist ❤️");

  } catch (err) {

    console.log(err);
    alert("Unable to add to wishlist.");

  }

};
  return (

    <div className="product-card">

      {product.is_new === 1 && (
        <span className="new-badge">NEW</span>
      )}

      {product.discount > 0 && (
        <span className="discount-badge">
          {product.discount}% OFF
        </span>
      )}

      <button
  className="wishlist-btn"
  onClick={handleWishlist}
>
  <FaHeart />
</button>

      <Link
        to={`/product/${product.id}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >

        <img
          src={image}
          alt={product.product_name}
          className="product-image"
        />

        <h3>{product.product_name}</h3>

      </Link>

      <div className="rating">

        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />

      </div>

      <div className="price">

        {product.discount > 0 && (

          <span className="old-price">

            ${product.old_price}

          </span>

        )}

        <span className="new-price">

          ${finalPrice}

        </span>

      </div>

      <div className="stock">

        {product.stock <= 5
          ? `🔥 Only ${product.stock} Left`
          : "✅ In Stock"}

      </div>

      <button
        className="cart-btn"
        onClick={handleAddToCart}
      >

        <FaShoppingCart />

        &nbsp; Add To Cart

      </button>

    </div>

  );
}

export default ProductCard;